import * as React from 'react';
import { observer } from 'mobx-react-lite';
import isPremium from 'owa-proofing-option/lib/utils/isPremium';
import ProofingTeachingCalloutFreeUser from './ProofingTeachingCalloutFreeUser';
import ProofingTeachingCalloutPremiumUser from './ProofingTeachingCalloutPremiumUser';

export interface ProofingTeachingCalloutProps {
    target: () => HTMLElement;
}

export default observer(function ProofingTeachingCallout(props: ProofingTeachingCalloutProps) {
    const { target } = props;
    const isPremiumUser: boolean = isPremium();
    return (
        <>
            {!isPremiumUser && <ProofingTeachingCalloutFreeUser target={target} />}
            {isPremiumUser && <ProofingTeachingCalloutPremiumUser target={target} />}
        </>
    );
});
